import { Component, Inject, EventEmitter, forwardRef, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CompanyService } from 'src/app/_service/company.service';
import { VesselService } from 'src/app/_service/vessel.service';
import { getCompanyData } from 'src/app/_model/company';

@Component({
  selector: 'app-rbac-edit',
  templateUrl: './rbac-edit.component.html',
  styleUrl: './rbac-edit.component.css'
})
export class RbacEditComponent implements OnInit, OnDestroy {
  companyList: getCompanyData[];
  currCompany: any;
  currVesselList: any[] = [];
  currSelectedVessels = new Set<any>();
  vesselListLoading = false;
  selectAllChecked = false;
  selectedVesselList: any[] = [];
  newCompanyList: any[] = [];
  

  constructor(
    private companyService: CompanyService,
    private vesselService: VesselService,
    public router: Router,
    public dialogRef: MatDialogRef<RbacEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.companyList = this.companyService.companyList;
    this.newCompanyList = this.companyList.map(company => {
      return {
        ...company,
        dispName: company.name || company.otherName,
        disabled: data?.selectedCompanies.includes(company.id),
      }
    });
  }
  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  getCompanyName(company: any) {
    return company ? company.name || company.otherName : "";
  }

  onCompanyChange() {
    this.vesselListLoading = true;
    this.selectAllChecked = false;
    this.currSelectedVessels.clear();
    if (!this.currCompany) return;
    this.vesselService.getVesselByManagerId(this.currCompany?.id).subscribe({
      next: async(value:any) => {
        this.vesselListLoading = false;
        this.currVesselList = value;
      },
      error: (error) => {
        console.error('Error fetching vessels:', error);
        this.vesselListLoading = false;
      },
    });
  }

  onSelectAllVesselsChange(event: any) {
    const checkbox = event.target as HTMLInputElement;
    this.selectAllChecked = checkbox.checked;

    if (this.selectAllChecked) {
      this.currVesselList.forEach(vessel => this.currSelectedVessels.add(vessel?.id))
    } else {
      this.currSelectedVessels.clear();
    }
  }

  onVesselChange(event: any) {
    const checkbox = event.target as HTMLInputElement;
    const vesselId = checkbox.value;

    if (checkbox.checked) {
      this.currSelectedVessels.add(vesselId);
    } else {
      this.currSelectedVessels.delete(vesselId);
    }

    this.selectAllChecked = this.currSelectedVessels.size === this.currVesselList.length;
  }

  isVesselSelected(vesselId: string) {
    return this.currSelectedVessels.has(vesselId);
  }

  saveCompany() {
    const returnVslList = this.currVesselList
      .filter(vessel => this.currSelectedVessels.has(vessel.id))
      .map(vessel => ({
        id: vessel.id,
        name: vessel.name || vessel.otherName,
      }));
    const returnData = { currSelectedCompany: {id: this.currCompany?.id, name: this.currCompany.dispName}, selectedVesselList: returnVslList };
    this.dialogRef.close(returnData);
  }
}
